import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { CountryDetails } from '../CountryDetails';
import { RoamersSegment } from '../RoamersSegment';

@Component({
  selector: 'app-message-delivery-statistics',
  templateUrl: './message-delivery-statistics.component.html',
  styleUrls: ['./message-delivery-statistics.component.scss']
})
export class MessageDeliveryStatisticsComponent implements OnInit {

  roamerSegmentForm: FormGroup;

  private dateToString = (date: any) => `${date.year}-${date.month}-${date.day}`;

  country = []
  dataSource = []
  network = []
  VPMNCountry = []
  VPMNnetwork = []
  VPMNtadig = []
  HPMNtadig = []
  showTable: boolean;
  startDate: any;
  endDate: any;
  messageCategory = ["MessageCategory1", "MessageCategory2", "MessageCategory3"]
  vpmnCountryList: any;
  vpmnNetworkList: any;
  vpmnTadigList: any;
  submitted = false;
  callVPMNNetwork: boolean;

  constructor(private formBuilder: FormBuilder, private endpointsService: EndpointsService,
    private backendApiService: BackendApiService, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.createRoamersSegmentForm()
    this.getVPMNCountryDetails()
  }

  createRoamersSegmentForm() {
    this.roamerSegmentForm = this.formBuilder.group({
      HPMNtadig: [sessionStorage.getItem('homeTadg')],
      country: [sessionStorage.getItem('homeCountryNameWithOp')],
      network: [sessionStorage.getItem('homeOp')],
      msgCatergory: ['all'],
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]],
      msidn: [],
      VPMNCountry: ['1'],
      VPMNnetwork: ['1'],
      VPMNtadig: ['1']

    });
  }

  changeDateEvent(targetCalendarId: any) {
    targetCalendarId.toggle();
  }

  search() {
    this.submitted = true;
    if(this.roamerSegmentForm.invalid){
      return;
    }
    const startDateFrom = this.roamerSegmentForm.get('startDate').value;
    const endDateTo = this.roamerSegmentForm.get('endDate').value;
    if (!startDateFrom && !endDateTo) {
      alert('Please Select Start and End dates');
      return;
    } else if (startDateFrom && !endDateTo) {
      alert('Please Select End Date');
      return;
    } else if (!startDateFrom && endDateTo) {
      alert('Please Select Start Date');
      return;
    } else if (startDateFrom && endDateTo) {
      const dateFrom = new Date();
      dateFrom.setDate(startDateFrom.day);
      dateFrom.setMonth(startDateFrom.month - 1);
      dateFrom.setFullYear(startDateFrom.year);
      const dateTo = new Date();
      dateTo.setDate(endDateTo.day);
      dateTo.setMonth(endDateTo.month - 1);
      dateTo.setFullYear(endDateTo.year);
      if (dateTo.getTime() < dateFrom.getTime()) {
        alert('End date can\'t be less than Start date');
        return;
      }
      this.startDate = formatDate(dateFrom, 'yyyy-MM-dd', 'en');
      this.endDate = formatDate(dateTo, 'yyyy-MM-dd', 'en');
      // this.loadTable = true;
    }
    this.getSearch();
  }

  getSearch(){
    let url = this.endpointsService.MESSAGE_DELIVERY_STATIC;
    let countryData = this.roamerSegmentForm.get('VPMNCountry').value;
    if (countryData) {
      url += "&country=" + countryData
    }
    let networkData = this.roamerSegmentForm.get('VPMNnetwork').value;
    if (networkData) {
      url += "&network=" + networkData
    }
    let tadigData = this.roamerSegmentForm.get('VPMNtadig').value;
    if (tadigData) {
      url += "&tadig=" + tadigData
    }
    // let msgCatergory = this.roamerSegmentForm.get('msgCatergory').value;
    // if (msgCatergory) {
    //   url += "&messageCategory=" + msgCatergory
    // }
    let startDate = this.roamerSegmentForm.get('startDate').value;
    if (startDate) {
      url += "&startDate=" + this.startDate;
    }
    let endDate = this.roamerSegmentForm.get('endDate').value;
    if (endDate) {
      url += "&endDate=" + this.endDate;
    }
    // let msidn = this.roamerSegmentForm.get('msidn').value;
    // if (msidn) {
    //   url += "&msisdn=" + msidn
    // }
    
    this.backendApiService.callToApi(url).subscribe(res => {
      this.dataSource = res;
      this.showTable = true;
    });
  }

  getCountryDetails() {
    this.backendApiService.callToApi(this.endpointsService.COUNTRY_DETAILS).subscribe(res => {
      this.country = res;
    });
  }

  networkValues() {
    this.getNetworkDetails()
  }

  getNetworkDetails() {
    let cntry = this.roamerSegmentForm.get('country').value.split("_")[1]
    
    this.backendApiService.callToApi(this.endpointsService.NETWORK_DETAILS
      + "&country=" + cntry)
      .subscribe(res => {
        this.network = res;
      });
  }

  async getVPMNCountryDetails() {
    const apiUrl = this.endpointsService.COUNTRY_DETAILS + '&userName=' + sessionStorage.getItem('ecowas_user_name');
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.vpmnCountryList = response;
    });
  }

  getVpmnNetworkAccordingToCountry(event: any) {
    if (event.target.value === '1') {
      this.roamerSegmentForm.controls.vpmnNetwork.setValue('1', { onlySelf: true });
    } else {
      this.getVpmnNetworkList(event.target.value).then();
    }
  }

  async getVpmnNetworkList(country: string) {   
    this.vpmnNetworkList = await this.backendApiService.callToApi(this.endpointsService.URL_GET_OPERATOR_LIST_BY_COUNTRY +
      '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&country=' + country)
      .toPromise();

    if (this.vpmnNetworkList === null) {
      alert('api response null. please contact administrator');
      return;
    } else {
      this.spinnerService.hide();
      if (this.vpmnNetworkList.length !== 0) {
        this.roamerSegmentForm.controls.VPMNnetwork.
          setValue(this.vpmnNetworkList[0].operator);
          this.getTadig();
        this.callVPMNNetwork = true;
      } else {
        this.callVPMNNetwork = false;
      }
      return;
    }
  }

  getTadig() {
    this.backendApiService.callToApi(
      this.endpointsService.URL_GET_CAMPAIGN_TADIG + '&country=' + this.roamerSegmentForm.get('VPMNCountry').value +
      '&operator=' + this.roamerSegmentForm.get('VPMNnetwork').value).
      subscribe(response => {
        if (response.length === 0) {
          return;
        }
        this.vpmnTadigList = response;
        this.roamerSegmentForm.get('VPMNtadig')
          .setValue(response[0].tapCode, {onlySelf: true});
      });
  }
  get f() {
    return this.roamerSegmentForm.controls;
  }

  reset(){
    this.spinnerService.show();
    this.createRoamersSegmentForm();
    this.showTable = false;
  }

}
